import { useState } from "react";
import { entranceLines } from "@/mocks/siteData";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function LatestAddress() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="address" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="最新地址"
          title="访问域名会调整，收藏本页就不会走丢"
          desc="受网络环境影响，包子漫画的访问地址可能不定期更换。与其记住某个容易失效的网址，不如把本页加入收藏夹——这里会持续更新当前可用的入口，并说明各线路的适用场景。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {entranceLines.map((line) => (
            <article
              key={line.name}
              className="reveal flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${line.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                  {line.status}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base text-foreground-950">{line.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{line.desc}</p>
            </article>
          ))}
        </div>

        <div className="reveal mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="flex flex-col justify-between rounded-lg border border-primary-200 bg-primary-50 p-6 lg:col-span-2">
            <div>
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-bookmark-3-line text-xl text-primary-600" aria-hidden="true" />
                一键收藏当前入口
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                点击下方按钮可复制本页地址，粘贴到浏览器收藏夹或备忘便签里。下次地址变动时，只要从收藏打开本页，就能重新找到最新入口，不必依赖搜索引擎。
              </p>
            </div>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className={copied ? "ri-check-line text-base" : "ri-file-copy-line text-base"} aria-hidden="true" />
                {copied ? "已复制本页地址" : "复制本页地址"}
              </button>
              <span className="text-xs text-foreground-500" role="status" aria-live="polite">
                {copied ? "已复制，建议粘贴到收藏夹保存。" : "地址仅用于收藏，不会上传任何信息。"}
              </span>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h3 className="flex items-center gap-2 font-heading text-base text-foreground-950">
              <i className="ri-shield-keyhole-line text-lg text-secondary-700" aria-hidden="true" />
              安全提示
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" aria-hidden="true" />
                只从本页或官方客户端内的入口进入，不点击来历不明的跳转链接。
              </li>
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" aria-hidden="true" />
                不轻信第三方“加速器 / 下载站”，避免安装捆绑程序。
              </li>
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-secondary-600" aria-hidden="true" />
                需要账号信息时，仅在官方页面内输入。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}